import { Routine, RoutineParams } from "src/app/models/Routine";

export class SaveRoutine {
    static readonly type = '[routine] saveRoutine';
    constructor(public routine: RoutineParams) {}
  }